"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mathMinFilter() {
    return function (input, max) {
        return Math.min(input, max);
    };
}
function mathMaxFilter() {
    return function (input, min) {
        return Math.max(input, min);
    };
}
function regReplaceFilter() {
    return function (input, regex, replace) {
        replace = replace || '';
        return input.replace(new RegExp(regex, 'gi'), replace);
    };
}
function hairColorFilter() {
    return function (input, table) {
        var matches = input.match(/(blo?|bra?|rot?|sc(hw?)?)/), color = matches ? matches[1] : '';
        return table ? table[color] : color;
    };
}
function dasherizeFilter() {
    return function (input) {
        return input.toLowerCase().replace(/[^a-z0-9]/g, '-');
    };
}
function toIntFilter() {
    return function (input) {
        var int = parseInt(input, 10);
        return isNaN(int) ? input : int;
    };
}
function removeFalsyFilter() {
    return function (input) {
        var result = input.filter(function (entry) { return entry; });
        return result;
    };
}
function encodeURIComponentFilter() {
    return function (input) {
        return encodeURIComponent(input);
    };
}
function removeAccentsFilter() {
    return function (input) {
        input = input.replace(/[ÀÁÂÃÄÅÆ]/g, 'A');
        input = input.replace(/[àáâãäåæ]/g, 'a');
        input = input.replace(/[Ç]/g, 'C');
        input = input.replace(/[ç]/g, 'c');
        input = input.replace(/[ÈÉÊË]/g, 'E');
        input = input.replace(/[èéêë]/g, 'e');
        input = input.replace(/[ÌÍÎÏ]/g, 'I');
        input = input.replace(/[ìíîï]/g, 'i');
        input = input.replace(/[Ñ]/g, 'N');
        input = input.replace(/[ñ]/g, 'n');
        input = input.replace(/[ÒÓÔÕÖØŒ]/g, 'O');
        input = input.replace(/[òóôõöøœ]/g, 'o');
        input = input.replace(/[ÙÚÛÜ]/g, 'U');
        input = input.replace(/[ùúûü]/g, 'u');
        input = input.replace(/[Ÿ]/g, 'Y');
        input = input.replace(/[ÿ]/g, 'y');
        return input;
    };
}
exports.default = angular.module('pb.filter', [])
    .filter('mathMin', mathMinFilter)
    .filter('mathMax', mathMaxFilter)
    .filter('regReplace', regReplaceFilter)
    .filter('dasherize', dasherizeFilter)
    .filter('toInt', toIntFilter)
    .filter('hairColor', hairColorFilter)
    .filter('removeFalsy', removeFalsyFilter)
    .filter('removeAccents', removeAccentsFilter)
    .filter('encodeURIComponent', encodeURIComponentFilter);
